import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { NewPurchaseUpgradesComponent } from '../new-purchase-upgrades/new-purchase-upgrades.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-google-review-modal',
  templateUrl: './google-review-modal.component.html',
  styleUrls: ['./google-review-modal.component.scss']
})
export class GoogleReviewModalComponent implements OnInit {

  @Input() public edit_review_data;

  googleReview: FormGroup;
  submitted = false;
  currentRate: any = 0;
  url_names: any;


  constructor(
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private router: Router,
    private local: LocalServiceService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    // console.log('==hee,',this.edit_review_data)

    this.googleReview = this.formBuilder.group({
      feedbackName: ['', [Validators.required]],
      feedback: ['', [Validators.required]]
    });

    this.get_all_url_names();
  }

  get googleReviewV() { return this.googleReview.controls; }

  dismiss() {
    this.modalService.dismissAll();
  }

  add_google_review() {
    this.submitted = true;

    if(this.googleReview.invalid) { return false; }

    if(this.currentRate == 0) {
      return this.toastr.error('Please choose the stars.');
    }

    let formData = new FormData();
    formData.append('feedbackNameId', this.googleReview.value.feedbackName);
    formData.append('description', this.googleReview.value.feedback);
    formData.append('star', this.currentRate);

    // console.log()

    this.auth.add_feedback_subadmin_google(formData).subscribe((response: any) => {
      this.toastr.success(response.message);
      location.reload()
      this.googleReview.reset();
      this.modalService.dismissAll();
      // NewPurchaseUpgradesComponent.reload()
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message)
      }
    });
  }

  get_all_url_names() {
    let formData = new FormData();
    formData.append('urlName', '');
    
    this.auth.get_feedback_url_name(formData).subscribe((response: any) => {
      this.url_names = response.body.names;
    }, (error) => {
      if (error.status == 401) {
        this.local.logout();
        this.router.navigate(['/admin'])
      }
    });
  }

}
